import React from 'react';
import { connect } from 'react-redux';
import poweredByLMI from './poweredByLMI.png';
import { headerMainLogoSelector } from '../../scenes/Organisation/OrganisationSelectors';
import { isBrandedLogoType } from './BrandedLogo';

function PoweredByLmiLogo({ logoType, className, alt = 'Powered by LMI Group', style }) {
  if (!isBrandedLogoType(logoType)) return null;

  return (
    <img
      src={poweredByLMI}
      alt={alt}
      className={className}
      style={{
        display: 'block',
        objectFit: 'contain',
        ...style,
      }}
    />
  );
}

export default connect(state => ({
  logoType: headerMainLogoSelector(state),
}))(PoweredByLmiLogo);
